<template>
    <v-dialog v-model="dialog" persistent>
        <v-card class="pt-5">
            <v-btn icon style="position: absolute; top: 4px; right: 4px" @click="close()"><v-icon>mdi-close</v-icon></v-btn>
            <vereinsdatenblatt-display v-if="selectedVereinId" :selectedVereinId="selectedVereinId" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="close()"><v-icon class="mr-2">mdi-arrow-left</v-icon>Zurück</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import VereinsdatenblattDisplay from "@/views/ergebnisdienst/vereinsdatenblatt/vereinsdatenblattDisplay";
export default {
    name: "verein-edit-datenblatt",
    components: {VereinsdatenblattDisplay},
    computed: {
        isOpen(){ return this.$route.query.datenblatt }
    },
    props: ['selectedVereinId'],
    data: () => ({
        dialog: false
    }),
    created(){
        if ( this.isOpen ) this.close()
    },
    methods: {
        close(){
            window.history.back()
        }
    },
    watch: {
        isOpen(){
            this.dialog = this.isOpen
        }
    }
}
</script>

<style scoped>

</style>